import React from 'react'
import Header from '../components/Header'
import {Signup} from '../components/Signup'
export const Signuppage = () => {
  return (
    <>
    <Header/>
    <Signup/>
    </>
  )
}
